import React, {  Component } from 'react';
import { connect } from 'react-redux';

/* dialogs*/
 import EmailSpecOverlayDialog from '../../dialogs/emailSpecOverlayDialog';
 import EmailSpecOverlayDialogSuccess from '../../dialogs/emailSpecOverlayDialogSuccess';

import { routes } from '../../../redux/api/routes';
let { pdfViewerLocalstorageVar } = routes;

class PDFViewer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showEmailSpecOverlayDialog: false,
			pdfPath: "",
			pdfLinkText: ""
		}
	}
	componentDidMount() {
		let localStrogeObj = this.props.getLocalStorageVar(pdfViewerLocalstorageVar);
		if(localStrogeObj) {
			this.setState({
				pdfPath: localStrogeObj.pdfPath,
				pdfLinkText: localStrogeObj.pdfLinkText
			});
		} else {
			//Close dialog if there is no localstorage object found
			window.close();
		}
	}

	printBrochure(event) {
		event.preventDefault();
		window.print();
	}

	handleClickEmailSpec(event) {
        event.preventDefault();
        this.setState({
            showEmailSpecOverlayDialog: true
        });
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    render() {
        return (
			<div className="pdfButtonsPage">
				<div className="pdfButtonsPage">
					<div className="buttons">
						<form>
							<button onClick={this.handleClickEmailSpec.bind(this)}><span className="withIcon withWhiteEmailIcon">Email Brochure</span></button>
							&nbsp;
							{/*<button onClick={this.printBrochure.bind(this)}><span className="withIcon withWhitePrintIcon">Print Brochure</span></button>*/}
						</form>
					</div>
					{this.state.pdfPath
						?<iframe className="pdf" src={this.state.pdfPath} scrolling="no" frameBorder="0">
						</iframe>
						:null
					}
					{this.state.showEmailSpecOverlayDialog?<EmailSpecOverlayDialog hideOrigin={true} specURL={this.state.pdfPath} specURLLinkText={this.state.pdfLinkText} emailSubject="GE Appliances Product Brochure" handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
               		{(this.props.state && this.props.state.brochure.emailSendSuccessDialog === true)?<EmailSpecOverlayDialogSuccess showDialog={true}/>:null}
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

PDFViewer = connect(mapStateToProps)(PDFViewer);
export default PDFViewer;



// WEBPACK FOOTER //
// ./src/App/components/common/PDFViewer/index.js